import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';

import { send_to_server } from '@/services/socketio_client_react/send_to_server';

import { RequestWorkspaceUpdateAvatar } from '@shared/dto/+workspace/workspace_entity/_requests/request_workspace_update_avatar';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_update_avatar = createAsyncThunkSafe<void, RequestWorkspaceUpdateAvatar>(
  ENUM__network_event_client_to_server.WORKSPACE_UPDATE_AVATAR,
  async (data): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_UPDATE_AVATAR, data);
  },
);

export function init_remote_workspace_update_avatar(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_update_avatar.pending, state => {})
    .addCase(remote_workspace_update_avatar.rejected, (state, action) => {})
    .addCase(remote_workspace_update_avatar.fulfilled, (state, action: PayloadAction) => {});
}
